"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-5 mb-4"
};
const _hoisted_2 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3" };
const _hoisted_3 = { class: "flex flex-col md:flex-row" };
const _hoisted_4 = { class: "flex items-start w-full md:w-1/3 py-2 md:pr-3.5" };
const _hoisted_5 = { class: "w-full text-base pt-3" };
const _hoisted_6 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_7 = { class: "flex items-center justify-end" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "text-base mb-3" };
const _hoisted_10 = { class: "border border-gray-dark border-opacity-50 overflow-auto flex" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "flex items-start w-full md:w-1/3 py-2 md:pl-3.5" };
const _hoisted_13 = { class: "w-56 text-base pt-3" };
const _hoisted_14 = { class: "flex items-start w-full md:w-1/3 py-2 md:pl-3.5 justify-end" };
const _hoisted_15 = { class: "btn-group flex" };
const _hoisted_16 = { class: "text-red" };
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const vue_3 = require("vue");
const vehicleTypeStore_1 = require("../../stores/vehicleType/vehicleTypeStore");
const RadioGroupInput_vue_1 = __importDefault(require("../../components/Form/RadioGroup/RadioGroupInput.vue"));
const TyreSearcher_vue_1 = __importDefault(require("./TyreSearcher.vue"));
const axaptaCustomerProductReturnStore_1 = require("../../stores/axaptaCustomerProductReturn/axaptaCustomerProductReturnStore");
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductDataForm',
    props: {
        customerProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        const props = __props;
        const axaptaCustomerProductReturnStore = (0, axaptaCustomerProductReturnStore_1.useAxaptaCustomerProductReturnStore)();
        const vehicleTypeStore = (0, vehicleTypeStore_1.useVehicleTypeStore)();
        const filter_invoice_id = (0, vue_3.ref)("");
        let filter_product_id = (0, vue_3.ref)("");
        let axaptaCustomerProductReturnsItemList;
        const filterProductList = () => {
            var _a;
            filter_product_id = (_a = props.customerProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.filterpid;
            if (!axaptaCustomerProductReturnsItemList) {
                axaptaCustomerProductReturnsItemList =
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns;
            }
            if (!filter_invoice_id.value && !filter_product_id) {
                return (axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                    axaptaCustomerProductReturnsItemList);
            }
            if (filter_invoice_id.value) {
                axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.filter((obj) => {
                        return obj.invoiceId === filter_invoice_id.value;
                    });
            }
            if (filter_product_id) {
                axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.filter((obj) => {
                        return obj.productId === filter_product_id;
                    });
            }
        };
        const selectedVehicleTypeTyrePositions = (0, vue_3.computed)(() => vehicleTypeStore.selectedVehicleTypeTyrePositions);
        (0, vue_3.watchEffect)(() => {
            if (props.customerProductReturnCreateRequest.filterpid === null) {
                filterProductList();
            }
        });
        return (_ctx, _cache) => {
            return (__props.customerProductReturnCreateRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("product_data", "Product Data", "customer_product_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("choose_tyre", "Product ID", "customer_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    ((0, vue_2.unref)(selectedVehicleTypeTyrePositions).length > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("tyre_position", "Tyre position", "customer_product_return")), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                                (0, vue_2.createVNode)(RadioGroupInput_vue_1.default, {
                                                    "show-input": false,
                                                    "show-validity": true,
                                                    "selected-class": "bg-gray",
                                                    options: (0, vue_2.unref)(selectedVehicleTypeTyrePositions)
                                                }, {
                                                    option: (0, vue_2.withCtx)(({ option }) => [
                                                        (0, vue_2.createElementVNode)("div", {
                                                            class: "w-32 p-2 border-r-1 border-gray-dark border-opacity-50 h-full",
                                                            innerHTML: option.text
                                                        }, null, 8, _hoisted_11)
                                                    ]),
                                                    _: 1
                                                }, 8, ["options"])
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, vue_2.createVNode)(TyreSearcher_vue_1.default, {
                                "customer-product-return-create-request": __props.customerProductReturnCreateRequest
                            }, null, 8, ["customer-product-return-create-request"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_id", "Invoice number", "customer_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                modelValue: filter_invoice_id.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter_invoice_id).value = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "inline-block btn btn-block btn-rounded btn-primary !rounded",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (filterProductList()))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("filter", "Filter", "customer_product_return")), 1)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                        (0, vue_2.createElementVNode)("p", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("filter_info_text_part1", "If the invoice or product you are looking for does not appear, it is because the invoice is probably more than 15 days old.", "customer_product_return")), 1),
                        (0, vue_2.createElementVNode)("p", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("filter_info_text_part2", "Our policy is that products purchased more than 15 days ago can no longer be returned.", "customer_product_return")), 1)
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
